import type { FlexProps } from "../flex/Flex";
import { Flex } from "../flex/Flex";
import type { FC } from "react";

const padding = [3, 3, 5];

export interface ICardProps extends FlexProps {
    mergeWithPreviousCard?: boolean;
}

export const Card: FC<ICardProps> = ({ mergeWithPreviousCard, children, ...rest }) => (
    <Flex
        flexDirection="column"
        backgroundColor="white"
        py={padding}
        px={padding}
        gap={4}
        mt={mergeWithPreviousCard ? -9 : "unset"}
        pt={mergeWithPreviousCard ? 9 : padding}
        {...rest}
    >
        {children}
    </Flex>
);
